export default __webpack_public_path__ + "static/media/no-metamask-nfts-image.5be517ca.png";